const quoteData = {
  meta: {
    title: "Rollbusch Quality Meats Website Quote",
    clientName: "Rollbusch Quality Meats",
    url: "https://rollbuschqualitymeats.com.au",
    date: "2025-11-26",
    quoteNumber: "Q-2025-RQM",
    preparedBy: "Jason Toomer",
    summary: [
      "Hi Erin, great to chat today and thank you for the clear direction you provided, it really helped me shape this quote around what Rollbusch needs right now.",
      "As discussed, this first version of the website focuses on strengthening your brand presence and supporting the momentum you already have through your strong social media accounts.",
      "The site will provide a clean, modern platform to showcase your stores, your award-winning products, and the quality of your smallgoods, while helping customers find the right location quickly and easily.",
      "It also lays the foundations for future online sales. When the time is right, we can easily extend this build into a full online shopping experience without re-building the whole site.",
      "If there is anything in the sections below you would like to talk through, please reach out. Everything is configurable so we can arrive at the version of the website that best fits your priorities and the pace you want to move at.",
      "2merative Web Design endeavours to build an ongoing partnership with every client. This is not a build-and-disappear relationship, ongoing support, guidance, and future enhancements are always available as your business grows.",
      "I’m excited to support Rollbusch with this next step",
       "Warm regards,",
"Jason"
    ]
  },

  business: {
    name: "2merative",
    abn: "61775724636",
    email: "hello@2merative.com",
    phone: "0498 135 744"
  },

  options: [
    {
      label: "4 page brochure site with store selector and awards showcase",
      sections: {
        projectApproach: [
          // Structure
          "Mobile-first build that prioritises fast and intuitive use on phones.",
          "Header with central Rollbusch logo and navigation links, disappearing on scroll and returning when scrolling stops.",
          "Footer with Rollbusch branding, contact details, and social media links.",

          // Home page
          "Hero store selector with four tabs: Store 1, Store 2, Store 3, and the Abattoir.",
          "Each tab displays intro text, address, opening hours, and key store highlights.",
          "Store-specific Google Maps embeds for fast navigation.",
          "Awards strip highlighting smallgoods awards.",
          "Rolling ticker for specials and seasonal offers (can be turned on/off anytime).",
          "Google reviews section for trust and social proof.",

          // Mobile contact bar
          "Mobile-only sticky bottom bar with Call Store and Email Store buttons.",
          "Selector modal for Store 1, Store 2, Store 3, and the Abattoir.",
          "Direct tel: and mailto: actions for each location.",

          // About page
          "About page telling the Rollbusch story, family background, abattoir operations, and commitment to quality.",
          "Photo sections and optional timeline layout.",

          // Awards page
          "Dedicated Awards page showing awards by year and category.",
          "Optional filters for Smallgoods, Sausages, Bacon, etc.",
          "Support for trophy/certificate photos provided by Rollbusch.",

          // Contact page
          "Fully integrated and secure contact form with name, email, phone, store selector, and message.",
          "Uses server-side validation, honeypot spam filtering, and secure routing.",
          "No external service required for handling submissions.",

          // Online Shop (future)
          "Placeholder Online Shop page for future expansion to Shopify or WooCommerce.",

          // Technical / SEO
          "Full SSL included across all pages.",
          "Optimised images and performance-focused build.",
          "Foundational SEO on every page (titles, descriptions, social tags).",
          "Google Analytics / GA4 ready (Rollbusch provides code).",
          "Brand colours and fonts matched to Rollbusch identity.",

          // Email
          "Setup of one professional email address (e.g. info@rollbuschqualitymeats.com.au).",

          // Content
          "Rollbusch provides photos, store details, and award information.",
          "Light content editing included.",
          ""
        ],

        oneOff: [
          {
            item:
              "4 page website build including hero store selector, awards showcase, ticker, reviews, secure contact form, and mobile quick-contact bar",
            cost: 3100
          },
          {
            item:
              "First year hosting with full SSL, backups, monitoring, and setup of one professional email address (included at no extra cost)",
            cost: 0
          },
          {
            item: "Domain name purchase for the first year (included at no extra cost)",
            cost: 0
          }
        ],

        recurring: [
          {
            item:
              "Annual hosting, SSL renewal, backups, monitoring (from Year 2 onwards)",
            costMonthly: 0,
            costYearly: 220
          },
          {
            item:
              "Domain name renewal (approx.) from Year 2 onwards",
            costMonthly: 0,
            costYearly: 25
          }
        ]
      }
    }
  ],

  gstRate: 0.1,

  totals: {
    subtotalExGst: 3100,
    gst: 310,
    totalIncGst: 3410
  },

  notes: [
    "This quote includes a 4 page site with store selector, awards, reviews, rolling ticker, secure contact form, and mobile contact bar.",
    "First year hosting and the initial domain name purchase are included at no extra cost as part of this build.",
    "Ongoing yearly costs from Year 2 are currently estimated at $220 hosting and approximately $25 domain name renewal.",
    "One professional email address is included.",
    "Rollbusch provides logos, photos, award details, and store information.",
    "All website files and the domain name become the property of Rollbusch Quality Meats on completion of the build.",
    "Online shop (Shopify or WooCommerce) can be quoted separately when required.",
    "Estimated build time is approximately 2-4 weeks from acceptance and receipt of all content."
  ],

  assumptionsExclusions: [
    "Advanced loyalty systems, memberships, or delivery platforms are not included.",
    "Product photography and long-form content writing are not included.",
    "Paid plugins or SMS integrations are not included unless requested.",
    "Additional email mailboxes beyond the first included setup.",
    "Social media management is not included."
  ],

  warrantySupport: [
    "30 day post-launch warranty for issues related to this build.",
    "Enhancements or new features available at $100/hr.",
    "Future eCommerce functionality will be quoted separately."
  ],

  acceptance: {
    validUntil: "2025-12-10",
    paymentTerms: "50% on acceptance and 50% on launch."
  }
};

export { quoteData };
export default quoteData;
